import { createAppStatusSelector } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
export const getParentCaresAboutNextIframeClick = createAppStatusSelector('caresAboutNextIframeClick');